import { render, staticRenderFns } from "./SimpleIndicator.vue?vue&type=template&id=670d6e29&scoped=true"
import script from "./SimpleIndicator.vue?vue&type=script&lang=js"
export * from "./SimpleIndicator.vue?vue&type=script&lang=js"
import style0 from "./SimpleIndicator.vue?vue&type=style&index=0&id=670d6e29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d6e29",
  null
  
)

export default component.exports